// extracted by mini-css-extract-plugin
module.exports = {"social-connect":"SocialConnect_social-connect__1i829","social-connect__separator":"SocialConnect_social-connect__separator__3KKBM"};